// src/rtkQuery/features/services/myVideo/videoApi.slice.ts

import { buildQuery } from "@/rtkQuery/lib";
import { baseApi } from "@/rtkQuery/features/services/baseApi";
import type { Video, ConfirmWatchResponse, WatchedVideo } from "@/rtkQuery/features/models/video.model";
import { VIDEO_API_ROUTES } from "@/rtkQuery/config/videoApi.config";

export const videoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllVideos: builder.query<Video[], void>({
      query: buildQuery(VIDEO_API_ROUTES.getAll, "GET"),
    }),

    confirmWatchVideo: builder.mutation<ConfirmWatchResponse, number>({
      query: (videoId) => ({
        url: `${VIDEO_API_ROUTES.confirmWatch}?videoId=${videoId}`,
        method: "POST",
      }),
    }),

    getWatchedVideos: builder.query<WatchedVideo[], void>({
      query: buildQuery(VIDEO_API_ROUTES.watchedVideos, "GET"),
      providesTags: ['WatchedVideos'],

    }),

  }),
  overrideExisting: false,
});

export const {
  useGetAllVideosQuery,
  useLazyGetAllVideosQuery,
  useConfirmWatchVideoMutation,
  useGetWatchedVideosQuery
} = videoApi;